import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

export interface TrackerItemMenuItem {
  key: string;
  label: React.ReactNode;
  onSelect: () => void;
  destructive?: boolean;
  testId?: string;
}

interface ITrackerItemMenuProps {
  items: TrackerItemMenuItem[];
  ariaLabel: string;
  testId?: string;
}

const TrackerItemMenu: React.FC<ITrackerItemMenuProps> = ({
  items,
  ariaLabel,
  testId = 'tracker-item-kebab-button',
}) => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      {open && (
        <div
          className="merged-activity-menu-backdrop"
          data-testid="tracker-item-menu-backdrop"
          onClick={close}
          aria-hidden="true"
        />
      )}
      <Dropdown isOpen={open} toggle={() => setOpen((v) => !v)} direction="down">
        <DropdownToggle
          tag="button"
          type="button"
          className="btn btn-link p-0 merged-activity-kebab"
          aria-label={ariaLabel}
          data-testid={testId}
        >
          <svg
            width={20}
            height={20}
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable={false}
          >
            <circle cx="12" cy="5" r="1.8" />
            <circle cx="12" cy="12" r="1.8" />
            <circle cx="12" cy="19" r="1.8" />
          </svg>
        </DropdownToggle>
        <DropdownMenu role="menu" end className="merged-activity-menu">
          {items.map((item) => (
            <DropdownItem
              key={item.key}
              role="menuitem"
              toggle={false}
              onClick={() => {
                setOpen(false);
                item.onSelect();
              }}
              className={item.destructive ? 'merged-activity-menuitem-destructive' : undefined}
              data-testid={item.testId}
            >
              {item.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default TrackerItemMenu;
